module.exports = __webpack_public_path__ + "img/tuin.5408dc72.png";